module.exports = __webpack_public_path__ + "img/baner_sm.d7ec4ad6.gif";